import { actionTypes } from "./constants";
const initialState = {
  saleAgentList: {
    list: [],
    total: 0,
  },
  agentList: {
    list: [],
    total: 0,
  },
  agentSubAccountList: {
    list: [],
    total: 0,
  },
  agentTypeList: {
    list: [],
    total: 0,
  },
  agentDetail: null,
  agentScore: null,
  agentListStrId: {
    list: [],
    total: 0,
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_AGENTLIST:
      return {
        ...state, agentList: action.data,
      };
    case actionTypes.SET_SALEAGENTLIST:
      return {
        ...state, saleAgentList: action.data,
      };
    case actionTypes.SET_AGENT_DETAIL:
      return {
        ...state, agentDetail: action.data,
      };
    case actionTypes.SET_AGENT_SCORE:
      return {
        ...state, agentScore: action.data,
      };
    case actionTypes.SET_AGENT_SUB_ACCOUNT_LIST:
      return {
        ...state, agentSubAccountList: action.data,
      };
    case actionTypes.SET_AGENT_TYPE_LIST:
      return {
        ...state, agentTypeList: action.data,
      };
    case actionTypes.SET_AGENTLIST_STR_ID:
      return {
        ...state, agentListStrId: action.data,
      };
    case actionTypes.SET_AGENT_OPTIONS:
      return {
        ...state, SET_AGENT_OPTIONS: action.data,
      };
    default:
      return state;
  }
};
